//import libraries
import React from "react";
import { TouchableOpacity, Text, View, Dimensions } from "react-native";
import MaterialIcon from "react-native-vector-icons/MaterialIcons";
import Ionicon from "react-native-vector-icons/FontAwesome5";
import { Loading } from "./Loading";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";
import theme from "app/Theme/Theme";

const { width } = Dimensions.get("window");

const Header = props => {
  const { isDisabled = false, onPress } = props;
  return (
    <View
      style={[
        styles.mainView,
        props.backgroundColor && { backgroundColor: props.backgroundColor },
        props.style && { ...props.style },
      ]}
    >
      <View style={styles.headerView}>
        <View style={styles.backIcon}>
          <TouchableOpacity
            hitSlop={{ top: 20, bottom: 20, left: 20, right: 20 }}
            onPress={onPress}
          >
            <Ionicon
              name="arrow-left"
              color={theme.colors["neutral.white"]}
              size={18}
            />
          </TouchableOpacity>
        </View>
        <View style={styles.textView}>
          <Text style={styles.textStyle}>{`${props.name}`}</Text>
        </View>
        <View style={styles.paramIcon}>
          {props.votes > 0 && (
            <Text style={styles.votesStyle}>{props.votes}</Text>
          )}
          {props.count > 0 && (
            <Text style={styles.textStyle}>{props.count} / 3</Text>
          )}
          {props.validateIcon &&
            !isDisabled &&
            (props.validateLoading ? (
              <Loading size={20} />
            ) : (
              <TouchableOpacity
                onPress={props.onPressValidate}
                hitSlop={{ top: 20, bottom: 20, left: 20, right: 20 }}
              >
                <MaterialIcon
                  name="check"
                  size={20}
                  color={theme.colors["neutral.white"]}
                />
              </TouchableOpacity>
            ))}
        </View>
      </View>
    </View>
  );
};

const styles = {
  mainView: {
    flexDirection: "column",
    width,
    zIndex: 10,
    backgroundColor: theme.colors["brand.500"],
    borderBottomWidth: 2,
    borderBottomColor: theme.colors["neutral.white"],
  },
  headerView: {
    flexDirection: "row",
    height: 45,
    width,
  },
  backIcon: {
    alignItems: "flex-start",
    justifyContent: "center",
    marginLeft: 15,
    flex: 1,
  },
  paramIcon: {
    alignItems: "flex-end",
    justifyContent: "center",
    marginRight: 15,
    flex: 1,
    top: 1,
  },
  textView: {
    flex: 3,
    justifyContent: "center",
    alignItems: "center",
  },
  textStyle: {
    fontSize: wp("4.2%"),
    color: theme.colors["neutral.white"],
    fontWeight: "bold",
  },
  votesStyle: {
    fontSize: wp("4.2%"),
    color: theme.colors["neutral.white"],
    borderRadius: 8,
    fontWeight: "bold",
    padding: 5,
    paddingTop: 2,
    paddingBottom: 2,
    borderWidth: 2,
    borderColor: theme.colors["neutral.white"],
  },
};

export { Header };
